function PrimaryButton({ children, onClick, href, variant = 'primary', type = 'button' }) {
  if (href) {
    return (
      <a className={`primary-button primary-button-${variant}`} href={href}>
        {children}
      </a>
    );
  }

  return (
    <button className={`primary-button primary-button-${variant}`} type={type} onClick={onClick}>
      {children}
    </button>
  );
}

export default PrimaryButton;
